<script lang="ts">
    import type {DomainDiff, UpdatedEntity} from "$lib/models/MasterdataDiff";
    import type {Installation} from "$lib/models/Installation";

    const {installationDiff, updatedInstallations}: {
        installationDiff: DomainDiff<Installation> | undefined,
        updatedInstallations: UpdatedEntity<Installation>[]
    } = $props()
</script>

<ul class="ml-1">
  <li>
    <span class="font-bold">New ({installationDiff?.added.length ?? 0}):</span>
    <br>
    {#each installationDiff?.added ?? [] as added (added.id)}
      <div class="pl-1">
        <i>Serial Number:</i> {added.serialNumber},
        <i>Status:</i> {added.status}
      </div>
    {/each}
  </li>
  <li>
    <span class="font-bold">Updated ({installationDiff?.updated.length ?? 0}):</span>
    <br>
    {#each updatedInstallations ?? [] as installation (installation.entity.id)}
      <div class="pl-1">
        <i>Serial Number:</i> {installation.entity.serialNumber},
        <i>Status:</i> {installation.entity.status}
      </div>
      <ul style="list-style-type: none; padding-left: 1rem;">
        {#each Object.entries(installation.changedFields) as [field, value] (field)}
          <li>
            <i>{field}:</i> {value.oldValue} &rarr; {value.newValue}
          </li>
        {/each}
      </ul>
    {/each}
  </li>
  <li>
    <span class="font-bold">Removed ({installationDiff?.removed.length ?? 0}):</span>
    <br>
    {#each installationDiff?.removed ?? [] as removed (removed.id)}
      <div class="pl-1">
        <i>Serial Number:</i> {removed.serialNumber},
        <i>Status:</i> {removed.status}
      </div>
    {/each}
  </li>
</ul>